var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.434 14a.434.434 0 0 1-.24-.796l.256-.17c.165-.11.087-.399-.104-.45a2.23 2.23 0 0 1-1.005-.592q-.675-.675-.675-1.659V4q0-1.383 1.284-2.025Q5.233 1.333 8 1.333q2.866 0 4.1.617 1.233.616 1.233 2.05v6.333q0 .984-.675 1.659a2.23 2.23 0 0 1-1.005.591c-.19.052-.268.34-.104.45l.258.171a.434.434 0 0 1-.241.796zm-.7-8.067a1 1 0 0 0 1 1H6.47a1 1 0 0 0 1-.995l.001-.267a1 1 0 0 0-1-1.004H4.733a1 1 0 0 0-1 1zm4.823-.023a1 1 0 0 0 1 1.023h1.71a1 1 0 0 0 1-1v-.266a1 1 0 0 0-1-1H9.563a1 1 0 0 0-1 .976zm-2.89 4.757a.97.97 0 0 0 .708-.292.96.96 0 0 0 .292-.708.96.96 0 0 0-.292-.709.96.96 0 0 0-.708-.291.96.96 0 0 0-.709.291.96.96 0 0 0-.292.709q0 .416.292.708.292.291.708.292m4.666 0a.97.97 0 0 0 .708-.292.96.96 0 0 0 .292-.708.97.97 0 0 0-.292-.709.96.96 0 0 0-.708-.291.96.96 0 0 0-.708.291.96.96 0 0 0-.292.709q0 .416.292.708.291.291.708.292M4.8 11.733h6.4c1.067 0 1.3-.834 1.3-1.4V8H3.523v2.133c0 .566.21 1.6 1.276 1.6M8 2.4c-2.133 0-3.684.267-4.267 1.332L8 3.733h4.267C11.733 2.667 10.133 2.4 8 2.4m.017 1.332 4.25.001H3.733z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.da9b451f7a2d38d649a8cad11349bc0e.svg";
export { ForwardRef as ReactComponent };